/**
 * OEBAK-Teilnehmer
 * REST-Endpoints fuer Teilnehmer-Applikation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageInfoVO } from './pageInfoVO';
import { KursInfoVO } from './kursInfoVO';


export interface KursInfoPageVO { 
    pageInfoVO: PageInfoVO;
    kursInfoVOList: Array<KursInfoVO>;
}

